import Apify from '@module/apify';

export default Apify({
  getInvoices: {
    path: '/api/v4/nu_invoices',
    method: 'GET',
  },

  getInvoice: {
    path: '{downloadUrl}',
    method: 'GET',
    pathExt: true,
  },
});
